import { render, staticRenderFns } from "./Calender.vue?vue&type=template&id=154e32c9&scoped=true&lang=pug&"
import script from "./Calender.vue?vue&type=script&lang=coffee&"
export * from "./Calender.vue?vue&type=script&lang=coffee&"
import style0 from "./Calender.vue?vue&type=style&index=0&id=154e32c9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154e32c9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCalendar } from 'vuetify/lib/components/VCalendar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCalendar,VIcon,VSheet,VToolbarTitle})
